/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many seconds are in a day?`)
};

const es_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos segundos hay en un día?`)
};

const de_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Sekunden hat ein Tag?`)
};

const nl_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel seconden zitten er in een dag?`)
};

const fr_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de secondes y a-t-il dans un jour ?`)
};

const it_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti secondi ci sono in un giorno?`)
};

const pt_br2_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos segundos tem em um dia?`)
};

const pt_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos segundos existem num dia?`)
};

const ja_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1日には何秒ありますか?`)
};

const zh_uc_time_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq1_q", locale)
	if (locale === "en") return en_uc_time_faq1_q(inputs)
	if (locale === "es") return es_uc_time_faq1_q(inputs)
	if (locale === "de") return de_uc_time_faq1_q(inputs)
	if (locale === "nl") return nl_uc_time_faq1_q(inputs)
	if (locale === "fr") return fr_uc_time_faq1_q(inputs)
	if (locale === "it") return it_uc_time_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq1_q(inputs)
	if (locale === "pt") return pt_uc_time_faq1_q(inputs)
	if (locale === "ja") return ja_uc_time_faq1_q(inputs)
	return zh_uc_time_faq1_q(inputs)
};